import apiProvider from './utilities/provider'

const url = 'tokens'

const apiTokens = {
  getSingle: (token) => apiProvider.getSingle(url, token),
}

export default apiTokens
